import Loading from "components/Loading";
import NoData from "components/NoData";
import Dashboard from "components/Template/Dashboard";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import EditWhite from "icons/edit-white.svg";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { listGroupById } from "services/group";
import { groupMemberList } from "services/manageFamilies";
import { getChannelsWithReports } from "utils/getChannelsWithReports";
import Header from "./Header";
import TableChannels from "./TableChannels";
import TableMembers from "./TableMembers";

type Props = {};

const GroupManagementShow: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [dataList, setDataList] = useState([]);
  const [dataListChannel, setDataListChannel] = useState<any[]>([]);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [loadingChannels, setLoadingChannels] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(false);

  const getDetails = async () => {
    try {
      setLoadingDetails(true);
      const { data } = await listGroupById(id);
      setName(data.name);
      setPaymentId(data.paymentId);
      setSubscriptionId(data.subscriptionId);
    } catch (error: any) {
    } finally {
      setLoadingDetails(false);
    }
  };

  const getListMembers = async () => {
    try {
      setLoadingMembers(true);
      const { data } = await groupMemberList(id);
      setDataList(data);
    } catch (error: any) {
    } finally {
      setLoadingMembers(false);
    }
  };

  const getChannelList = async () => {
    try {
      setLoadingChannels(true);
      setTimeout(async () => {
        const data = await getChannelsWithReports(id);
        setDataListChannel(data);
        setLoadingChannels(false);
      }, 50000);
    } catch (error: any) {
      setLoadingChannels(false);
    }
  };

  useEffect(() => {
    setId(history.location.pathname.split("/")[2]);
    if (id) {
      getDetails();
      getListMembers();
      getChannelList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, id]);

  return (
    <Dashboard
      title={name}
      icon={ArrowLeft}
      breadcrumb={[
        { name: "Manage Families", active: false, path: "/manage-families" },
        { name: `${name}`, active: true },
      ]}
      subscriptionId={subscriptionId}
      paymentId={paymentId}
      groupName={name}
      children={
        <>
          <Loading loading={loadingDetails || loadingMembers} />
          {!loadingDetails && !loadingMembers ? (
            <>
              <TableMembers
                memberList={dataList}
                groupId={id}
                rechargeMembers={getListMembers}
              />
              <Header
                icon={EditWhite}
                groupId={id}
                groupName={name}
                isMemberData={dataList.length > 0}
              />
              <TableChannels
                listChannel={dataListChannel}
                groupId={id}
                groupName={name}
                rechargeChannels={getChannelList}
                isLoading={loadingChannels}
              />
            </>
          ) : (
            <NoData />
          )}
        </>
      }
    />
  );
};

export default GroupManagementShow;
